import ApiManager from '@/utils/ApiManager'
import _ from 'lodash'
import Constants from '@/utils/Constants'

const state = {
  message: {
    content: '',
    type: ''
  },
  initLoaded: false,
  contractList: {
    loading: false,
    items: []
  },
  userList: {
    contractId: null,
    loading: false,
    items: [
      { text: '全ユーザー', value: 0 }
    ]
  },
  noticeItem: null,
  noticeTarget: [
    { text: '全体', value: 0 },
    { text: '企業', value: 1 },
    { text: '個人', value: 2 },
    { text: '小売社外全体', value: 3 }
  ]
}

const actions = {
  /**
   * お知らせデータを追加
   */
  async addNotice ({ state, commit }, notice) {
    this.dispatch('loading/loadingPagePlus')
    let type = 'success'
    const response = await ApiManager.request('Notice').noticeAdd(
      notice
    )
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    this.dispatch('loading/loadingPageMinus')
  },
  /**
   * お知らせデータを編集
   */
  async editNotice ({ state, commit }, notice) {
    this.dispatch('loading/loadingPagePlus')
    let type = 'success'
    const response = await ApiManager.request('Notice').noticeEdit(
      notice
    )
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    this.dispatch('loading/loadingPageMinus')
  },
  async getContractList ({ state, commit }, { pageNo, sortField, sortType, freeword, isFirst }) {
    commit('setListLoading', true)
    const response = await ApiManager.request('Contract').contractList(
      pageNo,
      0,
      sortField,
      freeword
    )
    response.data.data.isFirst = isFirst
    commit('setList', response.data.data)
  },
  async getUserList ({ state, commit }, { contractId }) {
    commit('setListLoading', true)
    const response = await ApiManager.request('User').userList(
      null,
      0,
      null,
      null,
      null,
      contractId
    )
    commit('setUserList', response.data.data)
  },
  async editNoticeItem ({ state, commit }, notice) {
    commit('setListLoading', true)

    commit('editNotice', notice)
  },
  async clearNoticeItem ({ state, commit }) {
    commit('editNotice', null)
  }

}

const mutations = {
  init (state, data) {
    state.message = {
      content: '',
      type: ''
    }
    // 初期ローディングの終了
    state.initLoaded = true
  },
  setMessage (state, data) {
    state.message = data
  },
  setListLoading (state, data) {
    // Listローディング状態
    // state.list.loading = data
    this.dispatch('loading/loadingPagePlus')
  },
  setList (state, data) {
    let items = []
    if (data.isFirst) {
      items.push({
        text: '全企業',
        value: 0
      })
    }

    _.forEach(data, function (item) {
      let contract = {}
      contract.value = item.id
      contract.text = item.name
      items.push(contract)
    })
    state.contractList.items = items
    this.dispatch('loading/loadingPageMinus')
  },
  setUserList (state, data) {
    let items = [{
      text: '全ユーザー',
      value: 0
    }]
    _.forEach(data, function (item) {
      let user = {}
      user.value = item.id
      user.text = item.user_name ? item.user_name : item.user_id
      items.push(user)
    })
    state.userList.items = items
    this.dispatch('loading/loadingPageMinus')
  },
  addNotice (state, data) {
    // Listローディング状態
    // state.list.loading = data
    this.dispatch('loading/loadingPageMinus')
  },
  editNotice (state, data) {
    state.noticeItem = data
    this.dispatch('loading/loadingPageMinus')
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
